// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CONTENT_CHANNELS: '/content/channels',
  CONTENT_CATEGORIES: '/content/categories',
  CATEGORY_CONTENT: '/content/categories/:id/manage-content',
  CATEGORY_CONTENT_ORDER:
    '/content/categories/:id/manage-content/content-order',
  CONTENT_VIDEOS: '/content/videos',
  CONTENT_SERIES: '/content/series',
  CONTENT_SERIES_SEASONS: '/content/series/:id/seasons',
  CONTENT_EPISODES: '/content/videos/season/:id',
  CONTENT_SHOWS: '/content/shows',
  CONTENT_PODCASTS: '/content/videos/show/:id',
  CONTENT_SEQUENCE: '/content/sequence',
  CONTENT_SEQUENCE_CATEGORY: '/categories',
  CONTENT_SEQUENCE_PLAYLIST: '/playlist',
  REPORTS_APP_SESSIONS: '/reports/app/sessions',
  CONTENT_TABS: '/content/tabs',
  SUBSCRIBERS: '/subscribers',
  ADMIN_USERS: '/users',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
